import { RequestService } from "../../../../../common/services/RequestService";
import { ASSIGN_DRIVER } from "../constants";

export const assignDriverRequest = async (order_id, driver_id) => {
  const response = await RequestService.put(
    ASSIGN_DRIVER.replace("{offer_id}", order_id),
    { ids: [driver_id] }
  );
  return response;
};
